import { render, staticRenderFns } from "./FomularioUsuario.vue?vue&type=template&id=63c111c9&"
import script from "./FomularioUsuario.vue?vue&type=script&lang=js&"
export * from "./FomularioUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports